import styled, { keyframes } from 'styled-components';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import { TableContainer, Table, Tr, Td, Tbody } from './index';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const SkeletonRow = styled.tr`
  @media (hover: hover) {
    &:hover {
      background: transparent;
    }
  }
  cursor: default;
  @media ${PHONE_MEDIA_QUERY} {
    td {
      background: ${({ theme }) => theme.background.secondary};
    }
  }
`;

const SkeletonCell = styled.td`
  padding: 12px;
  vertical-align: middle;
  border-bottom: 1px solid ${({ theme }) => theme.border.secondary};
  @media ${PHONE_MEDIA_QUERY} {
    padding: 0px;
    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;

const SkeletonRect = styled.div`
  width: 100%;
  height: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    height: 67px;
  }
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.background.secondary} 25%,
    ${({ theme }) => theme.special.skeleton} 50%,
    ${({ theme }) => theme.background.secondary} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 2s infinite;
`;

const TableSkeleton = ({ rows = 3, columns = 4 }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <Table>
      <Tbody>
        {[...Array(rows)].map((_, rowIndex) => (
          <>
            {isMobile ? (
              <>
                <SkeletonRow key={rowIndex}>
                  <SkeletonCell style={{ width: '100%' }}>
                    <SkeletonRect />
                  </SkeletonCell>
                </SkeletonRow>
              </>
            ) : (
              <>
                <SkeletonRow key={rowIndex}>
                  <SkeletonCell style={{ width: '20%' }}>
                    <SkeletonRect />
                  </SkeletonCell>
                  <SkeletonCell style={{ width: '10%' }}>
                    <SkeletonRect />
                  </SkeletonCell>
                  <SkeletonCell style={{ width: '10%' }}>
                    <SkeletonRect />
                  </SkeletonCell>
                  <SkeletonCell style={{ width: '10%' }}>
                    <SkeletonRect />
                  </SkeletonCell>
                </SkeletonRow>
              </>
            )}
          </>
        ))}
      </Tbody>
    </Table>
  );
};

export default TableSkeleton;
